import * as React from 'react';
import Dialog from '@mui/material/Dialog';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreen(props) {
    // const classes = useStyles();
    const { title, open, children } = props
    // const [resData, setresData] = useState()
    function handleClose(e) {
        //  console.log("rowStrAll",e);
        props.closeDialog(e[0]);
    }
    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{
                position: 'relative',
                backgroundColor: "#546e7a !important",
                borderBottom: "0",
                marginBottom: "0",
            }}>
                <Toolbar>
                    <Typography sx={{
                        ml: 2, flex: 1,
                        // ...defaultFont, 
                        flex: 1,
                    }} variant="h6" component="div">
                        {title}
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>

                </Toolbar>
            </AppBar>
            {children}
        </Dialog>
    );
}
FullScreen.prototype = {
    open: PropTypes.bool,
    title: PropTypes.string,
    children: PropTypes.node
}
FullScreen.defaultProps = {
    open: false,
}